import { type FunctionComponent } from 'react';
import { type FieldError, type FieldErrors } from 'react-hook-form';
import ReportIcon from '../../svgs/report.svg';

export type InputMessageProps = {
	invalid?: boolean;
	invalidMessage?: string | FieldError | FieldErrors;
	description?: string;
};

export const InputMessage: FunctionComponent<InputMessageProps> = ({ invalid, invalidMessage, description }) => {
	if (invalid && invalidMessage) {
		return (
			<div className={`f7 mt1 theme-error flex items-center gc1`} data-testid="inputMessage">
				<ReportIcon className="f5 minw1" data-testid="ReportIcon" /> <>{invalidMessage}</>
			</div>
		);
	} else if ((!invalid && description) || (invalid && !invalidMessage && description)) {
		return (
			<div className={`f7 mt1 theme-grey flex items-center gc1`} data-testid="inputMessage">
				{invalid && <ReportIcon className="f5 theme-error" data-testid="ReportIcon" />}
				{description}
			</div>
		);
	} else {
		return null;
	}
};
